import CommonSharedFileDetail from '../../../common/pages/secure/SharedFileDetail'
import Config from '../../../Config'

class SharedFileDetail extends CommonSharedFileDetail {
  constructor (props) {
    super(props)
    this.apiUrl = Config.companyAdminApiUrl.systemSettings
    this.apiUrlToDownlaod = Config.companyAdminApiUrl.sharedFileDownlaod
    this.userRoleUrl = 'company_admin'
    this.userRole = 'companyAdmin'
    this.isShowingEditButton = false
    this.isShowingDeleteButton = false
  }
}

export default SharedFileDetail



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/SharedFileDetail.js